<div class="list-element-add-remove">
    @if (label() && label() !== '') {
        <div class="label">
            {{ label() }}

            @if (currentList() | isItems) {
                <div class="count-ap-in-bag">
                    {{ currentList() | countAvailableAp:lists() }}&nbsp;<mho-icon-ap></mho-icon-ap>
                </div>
            }

            @if (!readonly()) {
                <div class="add-remove">
                    <ng-container *ngTemplateOutlet="buttonRemove"></ng-container>
                    <ng-container *ngTemplateOutlet="buttonAdd"></ng-container>
                </div>
            }
        </div>
    }
    <div class="editable-container">
        <div class="list">
            @for (item of currentList(); track $index) {
                @let element_label = $any(item.label && item.label[$any(locale)] ? item.label[$any(locale)] : item.label);
                @if (readonly()) {
                    <img [ngSrc]="HORDES_IMG_REPO + item.img" [title]="element_label" width="16" height="16">
                } @else {
                    <!-- Clic : sélecteur de quantité dans une liste à quantités, retrait sinon. -->
                    <img [ngSrc]="HORDES_IMG_REPO + item.img" [title]="element_label" role="button" tabindex="0"
                         (click)="onElementClick(item, $event)" (keydown.enter)="onElementClick(item, $event)"
                         style="cursor: pointer" width="16" height="16">
                }
            }
        </div>
        @if (!label() && !readonly()) {
            <div class="add-remove">
                <ng-container *ngTemplateOutlet="buttonAdd"></ng-container>
                <ng-container *ngTemplateOutlet="buttonRemove"></ng-container>
            </div>
        }
    </div>
</div>

<ng-template #buttonAdd>
    <img [ngSrc]="HORDES_IMG_REPO + 'icons/small_more.gif'" [matMenuTriggerFor]="menuAdd.menu()"
         [matMenuTriggerData]="{menuLabel: addLabel(), lists: lists()}" width="16" height="16">
</ng-template>
<ng-template #buttonRemove>
    @if (currentList().length > 0) {
        <img [ngSrc]="HORDES_IMG_REPO + 'icons/small_less.gif'" [matMenuTriggerFor]="menuRemove.menu()"
             [matMenuTriggerData]="{menuLabel: removeLabel(), list: currentList(), emptyLabel: emptyLabel()}" width="16" height="16">
    }
</ng-template>

<mho-menu-add #menuAdd="menuAdd" (add)="add.emit($event);" [class]="class()" [keepOpen]="keepOpen()" [lists]="lists()" [(sortMode)]="sortMode"></mho-menu-add>
<mho-menu-remove #menuRemove="menuRemove" (remove)="remove.emit($event)" (empty)="empty.emit($event)" [class]="class()"></mho-menu-remove>

<!-- Sélecteur de quantité, ouvert dans un overlay mais créé dans la vue du composant (voir quantity_outlet). -->
<ng-container #quantityOutlet></ng-container>
<ng-template #quantityTemplate>
    @if (quantity_item(); as item) {
        <div class="quantity-selector" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" role="group"
             [attr.aria-label]="$any(item.label[$any(locale)] ? item.label[$any(locale)] : item.label)">
            <img [ngSrc]="HORDES_IMG_REPO + item.img" alt="" width="16" height="16">
            <button mat-icon-button type="button" (click)="decreaseQuantity(item)" aria-label="Retirer un exemplaire" i18n-aria-label>
                <mat-icon>remove</mat-icon>
            </button>
            <span class="quantity-value">{{ quantityOf(item.id) }}</span>
            <button mat-icon-button type="button" (click)="increaseQuantity(item)" aria-label="Ajouter un exemplaire" i18n-aria-label>
                <mat-icon>add</mat-icon>
            </button>
        </div>
    }
</ng-template>
